import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  email: '',
  verified_at: null,
  premium_points: 0,
  backup_points: 0,
  language: 0,
  location: '',
  real_name: '',
  avatar: null,
  birth_day: '',
  authority: [],
  role: null,
};

export const userSlice = createSlice({
  name: 'auth/user',
  initialState: initialState,
  reducers: {
    loginUser: (_, action) => action.payload,
    logoutUser: () => initialState,
    updatePremiumPoints: (state, action) => {
      state.premium_points = action.payload
    },
    updateBalance: (state, action) => {
      state.premium_points = action.payload?.premium_points ?? state.premium_points
      state.backup_points = action.payload?.backup_points ?? state.backup_points
    },
    updateAccount: (state, action) => {
      Object.assign(state, action.payload)
    }
  },
});

export const { loginUser, logoutUser, updateBalance, updatePremiumPoints, updateAccount } = userSlice.actions;

export default userSlice.reducer;
